import { render } from "./AllResultsFileUpload.vue?vue&type=template&id=56f3b7c5"
import script from "./AllResultsFileUpload.vue?vue&type=script&lang=js"
export * from "./AllResultsFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/results/AllResultsFileUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56f3b7c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56f3b7c5', __exports__)) {
    console.log('reload')
    api.reload('56f3b7c5', __exports__)
  }
  
  module.hot.accept("./AllResultsFileUpload.vue?vue&type=template&id=56f3b7c5", () => {
    console.log('re-render')
    api.rerender('56f3b7c5', render)
  })

}


export default __exports__